// extracted by mini-css-extract-plugin
export default {"fieldset":"Company_fieldset__fjgkT","actions":"Company_actions__53HpI"};